/* import __COLOCATED_TEMPLATE__ from './attribute-creation-type-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();